import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
})
export class FileSizePipe implements PipeTransform {
  transform(nbrBytes: number): string {
    return `${(nbrBytes / 1024 / 1024).toFixed(2)} Mo`;
  }
}
